import { type SVGProps } from "react";

const WaveyIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
      width={24}
        height={24}
    viewBox="0 0 256 256"
    {...props}
  >
    <g
      stroke="none"
      strokeWidth="0"
      strokeDasharray="none"
      strokeLinecap="butt"
      strokeLinejoin="miter"
      strokeMiterlimit="10"
      fill="none"
      fillRule="nonzero"
      opacity="1"
      transform="translate(1.407 1.407) scale(2.81 2.81)"
    >
      <path
        d="M 69.986 79.004 H 20.013 c -4.959 0 -8.994 -4.034 -8.994 -8.993 V 40.183 c 0 -4.959 4.035 -8.994 8.994 -8.994 h 49.973 c 4.959 0 8.994 4.035 8.994 8.994 v 29.828 C 78.98 74.97 74.945 79.004 69.986 79.004 z M 20.013 33.189 c -3.856 0 -6.994 3.137 -6.994 6.994 v 29.828 c 0 3.856 3.137 6.993 6.994 6.993 h 49.973 c 3.856 0 6.994 -3.137 6.994 -6.993 V 40.183 c 0 -3.856 -3.138 -6.994 -6.994 -6.994 H 20.013 z"
        stroke="none"
        strokeWidth="1"
        strokeDasharray="none"
        strokeLinecap="round"
        strokeLinejoin="miter"
        strokeMiterlimit="10"
        fill="currentColor"
        fillRule="nonzero"
        opacity="1"
      />
      <path
        d="M 33.375 54.977 c -2.757 0 -5 -2.243 -5 -5 s 2.243 -5 5 -5 s 5 2.243 5 5 S 36.132 54.977 33.375 54.977 z M 33.375 46.977 c -1.654 0 -3 1.346 -3 3 s 1.346 3 3 3 s 3 -1.346 3 -3 S 35.029 46.977 33.375 46.977 z"
        stroke="none"
        strokeWidth="1"
        strokeDasharray="none"
        strokeLinecap="round"
        strokeLinejoin="miter"
        strokeMiterlimit="10"
        fill="currentColor"
        fillRule="nonzero"
        opacity="1"
      />
      <path
        d="M 56.625 54.977 c -2.757 0 -5 -2.243 -5 -5 s 2.243 -5 5 -5 s 5 2.243 5 5 S 59.382 54.977 56.625 54.977 z M 56.625 46.977 c -1.654 0 -3 1.346 -3 3 s 1.346 3 3 3 s 3 -1.346 3 -3 S 58.279 46.977 56.625 46.977 z"
        stroke="none"
        strokeWidth="1"
        strokeDasharray="none"
        strokeLinecap="round"
        strokeLinejoin="miter"
        strokeMiterlimit="10"
        fill="currentColor"
        fillRule="nonzero"
        opacity="1"
      />
      <path
        d="M 56.625 68.912 h -23.25 c -0.552 0 -1 -0.447 -1 -1 s 0.448 -1 1 -1 h 23.25 c 0.553 0 1 0.447 1 1 S 57.178 68.912 56.625 68.912 z"
        stroke="none"
        strokeWidth="1"
        strokeDasharray="none"
        strokeLinecap="round"
        strokeLinejoin="miter"
        strokeMiterlimit="10"
        fill="currentColor"
        fillRule="nonzero"
        opacity="1"
      />
      <path
        d="M 12.02 67.668 H 7.311 C 3.28 67.668 0 64.389 0 60.357 v -9.039 c 0 -4.031 3.28 -7.311 7.311 -7.311 h 4.708 c 0.552 0 1 0.448 1 1 v 21.66 C 13.02 67.221 12.572 67.668 12.02 67.668 z M 7.311 46.008 C 4.382 46.008 2 48.39 2 51.318 v 9.039 c 0 2.929 2.382 5.311 5.311 5.311 h 3.708 v -19.66 H 7.311 z"
        stroke="none"
        strokeWidth="1"
        strokeDasharray="none"
        strokeLinecap="round"
        strokeLinejoin="miter"
        strokeMiterlimit="10"
        fill="currentColor"
        fillRule="nonzero"
        opacity="1"
      />
      <path
        d="M 82.689 67.668 H 77.98 c -0.553 0 -1 -0.447 -1 -1 v -21.66 c 0 -0.552 0.447 -1 1 -1 h 4.709 c 4.031 0 7.311 3.279 7.311 7.311 v 9.039 C 90 64.389 86.721 67.668 82.689 67.668 z M 78.98 65.668 h 3.709 c 2.929 0 5.311 -2.382 5.311 -5.311 v -9.039 c 0 -2.929 -2.382 -5.311 -5.311 -5.311 H 78.98 V 65.668 z"
        stroke="none"
        strokeWidth="1"
        strokeDasharray="none"
        strokeLinecap="round"
        strokeLinejoin="miter"
        strokeMiterlimit="10"
        fill="currentColor"
        fillRule="nonzero"
        opacity="1"
      />
      <path
        d="M 48.812 33.189 h -7.623 c -0.285 0 -0.557 -0.122 -0.747 -0.335 c -0.19 -0.213 -0.28 -0.497 -0.247 -0.78 l 1.182 -10.213 c 0.063 -0.549 0.565 -0.943 1.108 -0.878 c 0.549 0.063 0.942 0.56 0.878 1.108 l -1.052 9.098 h 5.378 l -1.053 -9.096 c -0.063 -0.548 0.329 -1.044 0.878 -1.108 c 0.554 -0.064 1.046 0.33 1.108 0.878 l 1.182 10.21 c 0.033 0.283 -0.057 0.567 -0.246 0.78 C 49.368 33.068 49.097 33.189 48.812 33.189 z"
        stroke="none"
        strokeWidth="1"
        strokeDasharray="none"
        strokeLinecap="round"
        strokeLinejoin="miter"
        strokeMiterlimit="10"
        fill="currentColor"
        fillRule="nonzero"
        opacity="1"
      />
      <path
        d="M 45 23.672 c -3.495 0 -6.338 -2.843 -6.338 -6.338 c 0 -3.495 2.843 -6.338 6.338 -6.338 s 6.338 2.843 6.338 6.338 C 51.338 20.829 48.495 23.672 45 23.672 z M 45 12.996 c -2.392 0 -4.338 1.946 -4.338 4.338 s 1.946 4.338 4.338 4.338 c 2.392 0 4.338 -1.946 4.338 -4.338 S 47.392 12.996 45 12.996 z"
        stroke="none"
        strokeWidth="1"
        strokeDasharray="none"
        strokeLinecap="round"
        strokeLinejoin="miter"
        strokeMiterlimit="10"
        fill="currentColor"
        fillRule="nonzero"
        opacity="1"
      />
    </g>
  </svg>
);

export default WaveyIcon;
